import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { ORDERS_SUMMARY } from 'api/query-keys.ts';
import type { OrderTotalsRes } from 'api/swagger';
import type { IOrdersFilter } from 'shared/stores';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs.ts';
import type { IWithPagination } from 'types/api-query.ts';

interface IParams extends IWithPagination {
  search?: string;
  filters?: IOrdersFilter;
  isHints?: boolean;
  isSkip?: boolean;
}

export const useGetOrdersSummary = (params?: IParams) => {
  const { search, filters, isSkip } = params || {};

  const qs = new URLSearchParams();
  if (search) qs.set('filter[search]', search);
  if (filters) setFiltersToQs<IOrdersFilter>(qs, filters);

  return useQuery<OrderTotalsRes>({
    queryKey: [ORDERS_SUMMARY, qs.toString()],
    queryFn: async () => {
      const { data } = await http.get<OrderTotalsRes>(`/v1/orders/total?${qs.toString()}`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 10,
    cacheTime: 10,
    enabled: !isSkip,
  });
};
